import {
	Carousel,
	CarouselContent,
	CarouselItem,
	type CarouselApi,
} from "@/components/ui/carousel";
import { cn } from "@/lib/utils";
import { useEffect, useRef, useState } from "react";
import usePartners from "../hooks/use-partners";

function OurPartners({ className }: { className?: string }) {
	const baseURL = import.meta.env.VITE_SERVER_API_URL;
	const { partners } = usePartners();
	const [api, setApi] = useState<CarouselApi>();
	const paused = useRef(false);

	useEffect(() => {
		if (!api) return;
		const interval = setInterval(() => {
			if (!paused.current) api.scrollNext();
		}, 2500);
		return () => clearInterval(interval);
	}, [api]);

	return (
		<div
			className={cn(
				"flex flex-col items-center gap-10 px-4 py-10 md:gap-16 md:py-20",
				className
			)}
		>
			<p className="web-heading-h4">Our Partners</p>

			<Carousel
				setApi={setApi}
				opts={{ loop: true }}
				className="w-full"
				onMouseEnter={() => (paused.current = true)}
				onMouseLeave={() => (paused.current = false)}
			>
				<CarouselContent className="-ml-6">
					{partners.map((partner, index) => (
						<CarouselItem
							key={`${partner.name}-${index}`}
							className="basis-1/3 pl-6 md:basis-1/5"
						>
							<a
								href={partner.url}
								target="_blank"
								rel="noopener noreferrer"
								className="flex items-center justify-center"
							>
								<img
									src={`${baseURL}/common/image/${partner.logoUrl}`}
									alt={partner.name}
									className="h-36 w-36 object-contain md:h-56 md:w-56"
								/>
							</a>
						</CarouselItem>
					))}
				</CarouselContent>
			</Carousel>
		</div>
	);
}

export default OurPartners;
